export enum ESlotCorrectionStatus {
  Normal = 0,
  Corrected = 1,
  Error = 2,
}
